import { Modal, Row, Col, Button, Rate, Grid } from 'antd';
import styled from 'styled-components'
import { CloseOutlined } from '@ant-design/icons'

const { useBreakpoint } = Grid;

const ModalContainer = styled(Modal)`
  .ant-modal-content {
    background: transparent;
  }
`;

const VideoModal = (props: any) => {
  const isMobile = useBreakpoint().xs;
  return (
    <ModalContainer
      destroyOnClose
      width={'80vw'}
      maskClosable={false}
      centered
      closable={false}
      bodyStyle={{ width: '100%', padding: 32, height: isMobile ? '50vh' : '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      footer={null}
      visible={props.modalVisible} onCancel={() => props.setModalVisible(false)}
    >
      <div><CloseOutlined onClick={() => props.setModalVisible(false)} style={{ color: '#fff', fontSize: 32, position: 'absolute', top: 0, right: 0, cursor: 'pointer' }} /></div>
      <iframe
        title='Youtube'
        id='player'
        // type='text/html'
        allowFullScreen
        src={`https://www.youtube.com/embed/Jqy4l39RBuc`}
        frameBorder='0'
        style={{ width: '100vw', height: '56.25vw', maxHeight: '90%' }}
        loading='lazy'
      />
    </ModalContainer>
  )
}

export default VideoModal;